import { Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { DashboardPage } from './pages/DashboardPage';
import { InboxDetailEmpty, InboxPdfDetail } from './components/inbox/InboxPdfDetail';
import { PcoDetailPage } from './pages/PcoDetailPage';
import { PcoLogPage } from './pages/PcoLogPage';
import { ReconciliationPage } from './pages/ReconciliationPage';
import { RollupDetailPage } from './pages/RollupDetailPage';
import { SettingsPage } from './pages/SettingsPage';
import { FeedbackAdminPage } from './pages/FeedbackAdminPage';
import { HelpIndexPage } from './pages/help/HelpIndexPage';
import { HelpTopicPage } from './pages/help/HelpTopicPage';
import { LoginPage } from './pages/login/LoginPage';
import { VerifyPage } from './pages/auth/VerifyPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/auth/ResetPasswordPage';
import { AcceptInvitePage } from './pages/auth/AcceptInvitePage';
import { PlaceholderPage } from './PlaceholderPage';
import { ProtectedRoute } from './lib/ProtectedRoute';

export function App() {
  return (
    <Routes>
      {/* Auth screens — the only routes reachable without a session. All four
          share AuthLayout; /reset and /accept-invite fire nothing on mount. */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot" element={<ForgotPasswordPage />} />
      <Route path="/reset" element={<ResetPasswordPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      <Route path="/auth/verify" element={<VerifyPage />} />

      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />}>
          <Route index element={<InboxDetailEmpty />} />
          <Route path="inbox/:dailyPdfId" element={<InboxPdfDetail />} />
        </Route>
        <Route path="/pcos" element={<PcoLogPage />} />
        <Route path="/pcos/:pcoId" element={<PcoDetailPage />} />
        <Route path="/pcos/:pcoId/:weekEndingDate" element={<RollupDetailPage />} />
        <Route path="/reconciliation" element={<ReconciliationPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/help" element={<HelpIndexPage />} />
        <Route path="/help/:topicSlug" element={<HelpTopicPage />} />
        <Route path="/admin/feedback" element={<FeedbackAdminPage />} />
      </Route>

      <Route path="*" element={<PlaceholderPage notFound />} />
    </Routes>
  );
}
